import { useEffect, useRef, useState, useTransition } from "react";
import { Modal, Button } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import "../../../dashboard/styles.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import axios from "axios";
import { FaAngleDown, FaAngleRight } from "react-icons/fa6";
import { LuShoppingBag } from "react-icons/lu";
import { IoMdSearch, IoMdArrowForward } from "react-icons/io";
import QrcDetails from "./QrcDetails";
import Card from "../../../../components/Card";
import QR1 from "../../../../assets/QR1/qr1.png";
import "./Style.css";
import { AiOutlineInfoCircle } from "react-icons/ai";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaFilePdf,
  FaShareAlt,
  FaDownload,
} from "react-icons/fa";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { AiOutlineClose } from "react-icons/ai";
import html2canvas from "html2canvas";
import Switch from "@mui/material/Switch";
import { CircularProgress } from "@mui/material";

import {
  Tabs,
  Tab,
  Box,
  // Button,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
  Grid,
  ListItemText,
} from "@mui/material";
import { MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import { GoDotFill, GoUpload } from "react-icons/go";
import {
  MdOutlineDone,
  MdOutlinePhoneEnabled,
  MdRestaurantMenu,
} from "react-icons/md";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import pdf from "../../../../assets/images/pdf.png";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import * as moment from "moment";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { useProjectName } from "../../../../Context/ProjectNameContext";
import { useTranslation } from "react-i18next";
import PaymentCheckout from "../../../../components/Payment/PaymentCheckoutCritical";
import TopupCheckoutCritical from "../../../../components/Payment/TopupCheckout";
import { getToken } from "../../../../utils/auth";

const CreateQrcTab = ({
  category,
  condition,
  advice,
  emergencyContact,
  conditionId,
  handleGetAdvice,
  available,
  tabChange,
  topupAvailable
}) => {
  const [qrcData, setQrcData] = useState(null);
  const [qrPopupOpen, setQrPopupOpen] = useState(false);
  const [qrImageUrl, setQrImageUrl] = useState("");
  const [desPage, setDesPage] = useState(null);
  const [desIndex, setDesIndex] = useState(null);
  const [qrcId, setQrcId] = useState(null);
  const { t, i18n } = useTranslation();

  const projectName = useProjectName();
  const location = useLocation();
const [userDetail, setUserDetail] = useState("");
    const fetchUserData = async () => {
      try {
        const token = getToken();
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/user`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setUserDetail(response?.data?.data);
      } catch(error) {
        console.error("Failed Fetching Details", error);
      }
    };
    useEffect(() => {
      fetchUserData();
    }, []);

  useEffect(() => {
    const hash = location.hash;
    const queryString = hash.split("?")[1];
    const params = new URLSearchParams(queryString);
    const tab = params.get("tab");

    if (tab === "2") {
      setSelectedTab(1);
    }
  }, [location]);

  const handleGenerateQrc = async (e) => {
    e.preventDefault();
    const missingFields = [];
    if (!formDataEdit.category) missingFields.push("Category");
    if (!formDataEdit.conditions?.length) missingFields.push("Conditions");
    if (!formDataEdit.emergencyContacts?.length)
      missingFields.push("Emergency Contacts");
    if (!formDataEdit.userProfile) missingFields.push("User Profile");
    if (!formDataEdit.personalAdvice) missingFields.push("Personal Advice");
    if (!formDataEdit.doctersAdvice) missingFields.push("Doctor's Advice");

    // Check if any field is missing
    if (missingFields.length > 0) {
      toast.error(`Missing fields: ${missingFields.join(", ")}`);
      return;
    }

    const payload = {
      userProfileData: {
        criticalUserProfileId: formDataEdit.userProfile,
      },
      categoryId: formDataEdit.category,
      conditionIds: formDataEdit.conditions,
      personalAdvice: formDataEdit.personalAdvice,
      doctersAdvice: formDataEdit.doctersAdvice,
      doctersAdviceDocLink: uploadedSingleFile,
      doctersReportsLink: uploadedSingleFile1,
      otherDocuments: finalUploadedFiles,
      emergencyContactIds: formDataEdit.emergencyContacts,
      communicationChannel: {
        enableEmail: false,
        enableWhatsapp: false,
        enableSMS: false,
        enableVoiceMessage: false,
      },
    };
    try {
      setLoadingFull(true);
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/qrc/generate`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response?.data?.message);
      topupAvailable();
      setSelectedTab(1);
      handleGetQrc();
      handleClear();
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoadingFull(false);
    }
  };
  const handleGetQrc = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/qrc/all?platform=critical-D`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setQrcData(response?.data?.data);
    } catch (error) {
      console.log("Failed Fetching qrc", error);
    }
  };
  useEffect(() => {
    handleGetQrc();
  }, []);
  const handleQrClick = (imageUrl) => {
    setQrImageUrl(imageUrl);
    setQrPopupOpen(true);
  };

  const [selectedTab, setSelectedTab] = useState(0);
  const [expandedRow, setExpandedRow] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [qrcCard, setQrcCard] = useState(false);
  const [qrcCardCode, setQrcCardCode] = useState(false);

  const handleShowCard = () => {
    window.scrollTo(0, 0);
    setShowDetails(false);
    setQrcCard(true);
  };
  const backQrc = () => {
    window.scrollTo(0, 0);
    setQrcCard(false);
    setShowDetails(true);
  };
  const backQrc1 = () => {
    window.scrollTo(0, 0);
    setQrcCardCode(false);
    setQrcCard(true);
  };
  const finalQRC = () => {
    window.scrollTo(0, 0);
    setQrcCard(false);
    setQrcCardCode(true);
  };
  const finalComplete = () => {
    window.scrollTo(0, 0);
    setQrcCard(false);
    setShowDetails(false);
    setQrcCardCode(false);
    setSelectedTab(1);
  };
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const data = [{ QRID: "ADC13HJHB2354", title: "My Luggage" }];

  const [table, setTable] = useState(false);

  const handleTable = () => {
    setTable(!table);
  };

  const [formData, setFormData] = useState({
    userName: "John Doe",
    address: "123 Main St, City, Country",
    age: 29,
    bloodType: "O+",
    personalAdvice: "Maintain a balanced diet and regular exercise routine.",
    doctorAdvice:
      "Follow the prescribed medication schedule and attend regular check-ups.",
    category: "Health & Wellness",
    conditions: "Hypertension, Diabetes",
    emergencyContacts: "Jane Doe (Wife) - +123 456 7890",
    communicationChannels: "Email, WhatsApp, SMS",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files,
    }));
  };
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState("");

  const handleChannelChange = (event) => {
    const { value, checked } = event.target;
    setSelectedChannels((prevState) =>
      checked
        ? [...prevState, value]
        : prevState.filter((channel) => channel !== value)
    );
  };

  const handlePackageChange = (event) => {
    setSelectedPackage(event.target.value);
  };

  const [showMenu, setShowMenu] = useState(false);
  const downloadQR = () => {
    const link = document.createElement("a");
    link.href = "/QR.png";
    link.download = "QR.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  const containerStyle = {
    padding: "20px",
    maxWidth: "600px",
    margin: "auto",
    fontFamily: "Arial, sans-serif",
    borderRadius: "12px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  };

  const labelStyle = {
    display: "flex",
    alignItems: "center",
    marginBottom: "15px",
  };

  const headingStyle = {
    width: "150px",
    fontWeight: "bold",
  };

  const inputStyle = {
    flexGrow: 1,
    padding: "8px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    outline: "none",
    fontSize: "14px",
  };

  const [selectedCardIndex, setSelectedCardIndex] = useState(null);
  const [cardDetails, setCardDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingFull, setLoadingFull] = useState(false);
  const [editModeIndex, setEditModeIndex] = useState(null);
  const [formDataEdit, setFormDataEdit] = useState({
    category: "",
    userProfile: "",
    personalAdvice: "",
    doctersAdvice: "",
    doctersAdviceDocLink: "",
    doctersReportsLink: "",
    conditions: [],
    emergencyContacts: [],
  });

  const handleCardClick = async (index, _id) => {
    // Toggle details visibility
    const token = getToken();
    setEditModeIndex(null);
    if (selectedCardIndex === index) {
      setSelectedCardIndex(null);
    } else {
      setSelectedCardIndex(index);
      setLoading(true);

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/qrc/${_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              // 'accept': '*/*'
            },
          }
        );
        setCardDetails(response.data.data);
      } catch (error) {
        console.error("Error fetching card details:", error);
      } finally {
        setLoading(false);
      }
    }
  };
  const [editQrcId, setEditQrcId] = useState("");
  const handleEditClick = (index) => {
    setEditModeIndex(index);
    if (selectedCardIndex === index) {
      setEditQrcId(cardDetails?._id);
      const oldFiles =
        cardDetails?.qrcContentId?.otherDocuments?.map((doc) => doc) || [];
      setUploadedFiles(oldFiles);
      setFinalUploadedFiles(oldFiles);
      setUploadedSingleFile(
        cardDetails?.qrcContentId?.doctersAdviceDocLink || ""
      );
      setUploadedSingleFile1(
        cardDetails?.qrcContentId?.doctersReportsLink || ""
      );
      setFormDataEdit({
        category: cardDetails?.qrcContentId?.categoryId?._id || "",
        personalAdvice: cardDetails?.qrcContentId?.personalAdvice || "",
        doctersAdvice: cardDetails?.qrcContentId?.doctersAdvice || "",
        userProfile:
          cardDetails?.qrcContentId?.criticalUserProfileId?._id || "",
        conditions:
          cardDetails?.qrcContentId?.conditionIds?.map(
            (condition) => condition._id
          ) || [],
        emergencyContacts:
          cardDetails?.qrcContentId?.emergencyContactIds?.map(
            (contact) => contact._id
          ) || [],
      });
    }
  };

  const handleEditClickclose = (index) => {
    setEditModeIndex("");
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormDataEdit({ ...formDataEdit, [name]: value });
  };

  const handleSaveClick = (index) => {
    // Save form data logic here
    setEditModeIndex(null); // Exit edit mode after saving
  };

  const [conditionAll, setConditionAll] = useState(null);
  const [categoryAll, setCategoryAll] = useState(null);
  const [finalUploadedFiles, setFinalUploadedFiles] = useState([]);

  const handleGetAllCategory = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/category/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCategoryAll(response?.data?.data);
    } catch (error) {
      console.log("Failed Fetching Category", error);
    }
  };

  const handleGetAllConditions = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/condition/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setConditionAll(response?.data?.data);
    } catch (error) {
      console.log("Failed Fetching Conditions", error);
    }
  };

  const [emergencyContactAll, setEmergencyContactAll] = useState(null);
  const [user, setUser] = useState([]);

  const handleGetAllContacts = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/emergencyContact/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setEmergencyContactAll(response?.data?.data);
    } catch (error) {
      console.log("Failed Fetching emergencyContact", error);
    }
  };
  const handleGetAllUsers = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/userprofile/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUser(response?.data?.data);
    } catch (error) {
      console.log("Failed Fetching User Profiles", error);
    }
  };
  useEffect(() => {
    handleGetAllCategory();
    handleGetAllConditions();
    handleGetAllContacts();
    handleGetAllUsers();
  }, [tabChange]);

  const handleChange1 = (event) => {
    const { name, value } = event.target;
    setFormDataEdit({
      ...formDataEdit,
      [name]: value,
    });
  };

  // Handle condition change (allows multiple selection)
  const handleConditionChange = (event) => {
    const value = event.target.value;
    setFormDataEdit({
      ...formDataEdit,
      conditions: typeof value === "string" ? value.split(",") : value,
    });
  };

  // Handle emergency contacts change (allows multiple selection)
  const handleEmergencyContactChange = (event) => {
    const value = event.target.value;
    setFormDataEdit({
      ...formDataEdit,
      emergencyContacts: typeof value === "string" ? value.split(",") : value,
    });
  };
  const handleSubmitEdit = async () => {
    const payload = {
      userProfileData: {
        criticalUserProfileId: formDataEdit.userProfile,
      },
      categoryId: formDataEdit.category,
      conditionIds: formDataEdit.conditions,
      personalAdvice: formDataEdit.personalAdvice,
      doctersAdvice: formDataEdit.doctersAdvice,
      doctersAdviceDocLink: uploadedSingleFile,
      doctersReportsLink: uploadedSingleFile1,
      otherDocuments: finalUploadedFiles,
      emergencyContactIds: formDataEdit.emergencyContacts,
      communicationChannel: {
        enableEmail: false,
        enableWhatsapp: false,
        enableSMS: false,
        enableVoiceMessage: false,
      },
    };
    const token = getToken();

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/qrc/${editQrcId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      handleGetQrc();
      setEditQrcId("");
      // Show success toast notification
      toast.success("Data updated successfully!");
      setEditModeIndex("");
      setSelectedCardIndex("");
      // Reset the form after successful submission
      setFormDataEdit({
        category: "",
        conditions: [],
        emergencyContacts: [],
      });
    } catch (error) {
      console.error("Error updating data:", error);

      // Show error toast notification
      toast.error(error?.response?.data?.message || "Failed to update data.");
    }
  };
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [file, setFile] = useState(null);
  const MAX_IMAGES = 4;

  const splitFileLink = (a) => {
    const x = a.split("_");
    const y = x[x.length - 1];
    return decodeURIComponent(y);
  };

  const handleRemoveFile = (fileToRemove) => {
    const updatedFiles = finalUploadedFiles.filter(
      (file) => file !== fileToRemove
    );
    setFinalUploadedFiles(updatedFiles);
    setUploadedFiles(updatedFiles);
  };

  const handleFileInputChange = async (event) => {
    const chosenFiles = Array.prototype.slice.call(event.target.files);

    // Ensure the old files are retained and new ones are added
    const updatedFiles = [...photos, ...chosenFiles];

    // Check for the max limit of images
    if (updatedFiles.length > MAX_IMAGES) {
      toast.error(`You can only upload up to ${MAX_IMAGES} files.`);
      return;
    }

    // File size validation
    for (let i = 0; i < chosenFiles.length; i++) {
      const file = chosenFiles[i];
      if (file.size > 1048576) {
        // 2MB size limit
        toast.error(
          "File is too large, please upload a file smaller than 1MB."
        );
        return; // Exit early if a file is too large
      }
    }

    // Update the state with the new files
    setPhotos(updatedFiles);

    try {
      const formData = new FormData();

      updatedFiles.forEach((file) => {
        formData.append("files", file);
      });

      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success(response?.data?.message);
      setUploadedFiles(response?.data?.data);

      // Combine new uploaded links with the previous links
      const updatedFinalFiles = [
        ...finalUploadedFiles,
        ...response?.data?.data,
      ];
      setFinalUploadedFiles(updatedFinalFiles);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to upload files.");
    }
  };

  const [singleFile, setSingleFile] = useState(null);
  const [uploadedSingleFile, setUploadedSingleFile] = useState(null);

  const handleSingleFileInputChange = async (event) => {
    const chosenFile = event.target.files[0]; // Select only the first file

    // File size validation
    if (chosenFile.size > 1048576) {
      // 1MB size limit
      toast.error("File is too large, please upload a file smaller than 1MB.");
      return; // Exit early if the file is too large
    }

    // Update the state with the selected file
    setSingleFile(chosenFile);

    try {
      const formData = new FormData();
      formData.append("file", chosenFile); // Only append the single file

      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/file/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success(response?.data?.message);
      setUploadedSingleFile(response?.data?.data); // Store the uploaded file details
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to upload file.");
    }
  };
  const [singleFile1, setSingleFile1] = useState(null);
  const [uploadedSingleFile1, setUploadedSingleFile1] = useState(null);

  const handleSingleFileInputChange1 = async (event) => {
    const chosenFile = event.target.files[0]; // Select only the first file

    // File size validation
    if (chosenFile.size > 1048576) {
      // 1MB size limit
      toast.error("File is too large, please upload a file smaller than 1MB.");
      return; // Exit early if the file is too large
    }

    // Update the state with the selected file
    setSingleFile1(chosenFile);

    try {
      const formData = new FormData();
      formData.append("file", chosenFile); // Only append the single file

      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/file/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success(response?.data?.message);
      setUploadedSingleFile1(response?.data?.data); // Store the uploaded file details
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to upload file.");
    }
  };

  const qrCodeDetail = (cardDetails) => {
    const handleCallClick = (number) => {
      window.location.href = `tel:${number}`;
    };

    const handleShare = (url) => {
      if (navigator.share) {
        navigator
          .share({
            title: "Shared Document",
            url: url,
          })
          .catch((error) => console.error("Error sharing", error));
      } else {
        alert(
          "Sharing is not supported in your browser. Copy the link manually: " +
            url
        );
      }
    };

    const handleDownload = (url) => {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.pdf");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    const handleDownloadMultiple = async (fileUrls) => {
      const downloadFile = (url) => {
        return fetch(url)
          .then((response) => response.blob())
          .then((blob) => {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = url.split("/").pop(); // Use the file name from the URL
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch((error) => {
            console.error("Error downloading file:", error);
          });
      };

      try {
        await Promise.all(fileUrls?.map((fileUrl) => downloadFile(fileUrl)));
      } catch (error) {
        console.error("Error in handleDownloadMultiple:", error);
      }
    };

    const hasDocumentLinks =
      cardDetails?.qrcContentId?.doctersAdviceDocLink ||
      cardDetails?.qrcContentId?.doctersReportsLink ||
      (cardDetails?.qrcContentId?.otherDocuments &&
        cardDetails.qrcContentId.otherDocuments.length > 0);

    const downloadSectionAsImage = () => {
      const section = document.querySelector(".previewcontainer");
      html2canvas(section).then((canvas) => {
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = "section-image.png";
        link.click();
      });
    };

    const handleShareSectionAsImage = () => {
      const section = document.querySelector(".previewcontainer");

      html2canvas(section).then((canvas) => {
        canvas.toBlob((blob) => {
          const file = new File([blob], "section-image.png", {
            type: "image/png",
          });

          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            navigator
              .share({
                files: [file],
                title: "Shared Section Image",
                text: "Here is the section image.",
              })
              .catch((error) => console.error("Error sharing:", error));
          } else {
            alert("Sharing is not supported in your browser.");
          }
        });
      });
    };

    return (
      <div className="previewcontainer">
        <div className="previewhead">
          <span style={{ textTransform: "uppercase" }}>DIRIDO</span>.com{" "}
          <span className="previewheadfree">{t("try_for_free")}</span>
        </div>
        <div className="previewscanned">{t("scanned_qr_code_message")}</div>

        <div className="profile-card">
          <div className="profile-details">
            <div className="name-location">
              {cardDetails?.qrcContentId?.criticalUserProfileId?.name || "N/A"}{" "}
              -{" "}
              {cardDetails?.qrcContentId?.criticalUserProfileId?.address
                ?.state || "N/A"}{" "}
              <FaMapMarkerAlt style={{ verticalAlign: "middle" }} />
            </div>
            <div className="profile-info" style={{textAlign:"center"}}>
              <img 
                src={cardDetails?.qrcContentId?.criticalUserProfileId?.profilePhotoLink || "./profile.png"}
                // src="./profile.png"
                alt="Profile"
                className="profile-image"
              />
              <div className="details">
                <p>
                  <strong>{t("blood_group")}:</strong>{" "}
                  {cardDetails?.qrcContentId?.criticalUserProfileId
                    ?.bloodType || "N/A"}
                </p>
                <p>
                  <strong>{t("dob")}:</strong>
                  {cardDetails?.qrcContentId?.criticalUserProfileId?.birthDate
                    ? moment(
                        cardDetails.qrcContentId.criticalUserProfileId.birthDate
                      ).format("MMMM D, YYYY")
                    : "N/A"}
                </p>
                <p>
                  <strong>{t("email_label")}:</strong>{" "}
                  {cardDetails?.qrcContentId?.criticalUserProfileId?.email1 ||
                    "N/A"}
                </p>
                {/* <p><strong>Problem:</strong> Hypertension</p> */}
              </div>
            </div>
          </div>
        </div>

        <div className="additional-info">
          <div className="contact-alert">
            <p>
              {t("emergency_contact")} -{" "}
              {cardDetails?.qrcContentId?.emergencyContactIds[0]?.firstName ||
                "N/A"}{" "}
              {cardDetails?.qrcContentId?.emergencyContactIds[0]?.lastName ||
                "N/A"}
              (
              {cardDetails?.qrcContentId?.emergencyContactIds[0]?.mobile ||
                "N/A"}
              )
            </p>
            <FaPhoneAlt
              size={20}
              style={{ verticalAlign: "middle", marginLeft: "8px" }}
              onClick={() =>
                handleCallClick(
                  cardDetails?.qrcContentId?.emergencyContactIds[0]?.mobile ||
                    ""
                )
              }
            />
          </div>
          <h1 className="waiting-help">{t("waiting_for_help")}</h1>
          <h1 className="waiting-help">{t("advising_here")}</h1>

          {/* <textarea className="advice-textarea" readOnly> */}
          <div
            style={{
              background: "#f9f9f9",
              border: "1px solid lightgray",
              padding: "10px",
              marginTop: "10px",
              borderRadius: "5px",
            }}
          >
            {cardDetails?.qrcContentId?.personalAdvice || "N/A"}
          </div>

          <h2 className="doctor-advice-heading">
            {t("doctor_advice_heading")}
          </h2>

          {/* <textarea className="advice-textarea" readOnly> */}
          <div
            style={{
              background: "#f9f9f9",
              border: "1px solid lightgray",
              padding: "10px",
              marginTop: "10px",
              borderRadius: "5px",
            }}
          >
            {cardDetails?.qrcContentId?.doctersAdvice || "N/A"}
          </div>

          <h2 className="doctor-advice-heading">{t("category")}</h2>

          <div
            style={{
              background: "#f9f9f9",
              border: "1px solid lightgray",
              padding: "10px",
              marginTop: "10px",
              borderRadius: "5px",
            }}
          >
            <p style={{ marginBottom: "5px", fontSize: "12px" }}>
              <strong>{t("name_label")} : </strong>{" "}
              {cardDetails?.qrcContentId?.categoryId?.categoryName || "N/A"}
            </p>
            <p style={{ marginBottom: "5px", fontSize: "12px" }}>
              <strong>{t("description")} : </strong>{" "}
              {cardDetails?.qrcContentId?.categoryId?.categoryDescription ||
                "N/A"}
            </p>
          </div>
          <h2 className="doctor-advice-heading">{t("conditions")}</h2>

          <div
            style={{
              background: "#f9f9f9",
              border: "1px solid lightgray",
              padding: "10px",
              marginTop: "10px",
              borderRadius: "5px",
            }}
          >
            {cardDetails?.qrcContentId?.conditionIds?.length > 0 ? (
              <ul style={{ paddingLeft: "20px", color: "#666" }}>
                {cardDetails?.qrcContentId?.conditionIds?.map((condition) => (
                  <li key={condition?._id} style={{ marginBottom: "10px" }}>
                    <p style={{ marginBottom: "5px", fontSize: "12px" }}>
                      <strong>{t("name_label")} : </strong>{" "}
                      {condition?.conditionName}
                    </p>
                    <p style={{ marginBottom: "5px", fontSize: "12px" }}>
                      <strong>{t("description")} : </strong>{" "}
                      {condition?.conditionDescription}
                    </p>
                  </li>
                ))}
              </ul>
            ) : (
              <p style={{ color: "#888" }}>{t("no_conditions_available")}</p>
            )}
          </div>
        </div>
        <div className="report-card">
          {hasDocumentLinks && (
            <div className="report-header">{t("download_or_share_report")}</div>
          )}
          <div className="report-actions">
            <div className="pdf-section">
              {cardDetails?.qrcContentId?.doctersAdviceDocLink && (
                <div className="pdf-icon-container">
                  <div>
                    <FaShareAlt
                      className="action-icon"
                      onClick={() =>
                        handleShare(
                          cardDetails.qrcContentId.doctersAdviceDocLink
                        )
                      }
                    />
                    <FaFilePdf size={38} className="pdf-icon" />
                    <FaDownload
                      className="action-icon"
                      onClick={() =>
                        handleDownload(
                          cardDetails.qrcContentId.doctersAdviceDocLink
                        )
                      }
                    />
                  </div>
                  <p>{t("advice")}</p>
                </div>
              )}

              {cardDetails?.qrcContentId?.doctersReportsLink && (
                <div className="pdf-icon-container">
                  <div>
                    <FaShareAlt
                      className="action-icon"
                      onClick={() =>
                        handleShare(cardDetails.qrcContentId.doctersReportsLink)
                      }
                    />
                    <FaFilePdf size={38} className="pdf-icon" />
                    <FaDownload
                      className="action-icon"
                      onClick={() =>
                        handleDownload(
                          cardDetails.qrcContentId.doctersReportsLink
                        )
                      }
                    />
                  </div>
                  <p>{t("report")}</p>
                </div>
              )}

              {cardDetails?.qrcContentId?.otherDocuments?.length > 0 && (
                <div className="pdf-icon-container">
                  <div>
                    <FaShareAlt
                      className="action-icon"
                      onClick={() =>
                        handleDownloadMultiple(
                          cardDetails.qrcContentId.otherDocuments?.map(
                            (doc) => doc.link
                          )
                        )
                      }
                    />
                    <FaFilePdf size={38} className="pdf-icon" />
                    <FaDownload
                      className="action-icon"
                      onClick={() =>
                        handleDownloadMultiple(
                          cardDetails.qrcContentId.otherDocuments?.map(
                            (doc) => doc.link
                          )
                        )
                      }
                    />
                  </div>
                  <p>{t("other")}</p>
                </div>
              )}
            </div>
            <div className="share-download">
              <FaShareAlt
                size={18}
                className="action-icon"
                onClick={handleShareSectionAsImage}
              />
              <h5>{t("download_or_share_page")}</h5>
              <FaDownload
                size={18}
                className="action-icon"
                onClick={downloadSectionAsImage}
              />
            </div>
          </div>
        </div>

        <div className="health-card">
          <div className="health-message">
            <div>{t("good_health_wish")}</div>
          </div>
          <div className="powered-by">
            <div>
              {t("powered_by")} {projectName}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const canvasRef = useRef(null);

  const handleDownloadQRCPaid = (cardDetails) => {
    const link = document.createElement('a');
    link.href = cardDetails.qrCodeUrl;
    link.download = 'QRCode.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadQRCFree = (details) => {
    const canvas = canvasRef.current;
    if (!canvas) {
      alert("Canvas element is not available.");
      return;
    }
  
    const context = canvas.getContext("2d");
    if (!context) {
      alert("Failed to get canvas context.");
      return;
    }
  
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.src = details.qrCodeUrl;
  
  
    image.onload = () => {
      const qrcUID = details.qrc_UID || "";
  
      // Font sizes and spacing
      const uidFontSize = 18;
      const linkFontSize = 10;
      const uidLineHeight = 18;
      const linkLineHeight = 14;
      const extraMargin = 10;
      const extraHeight = uidLineHeight + linkLineHeight + extraMargin;
  
      // Set canvas size
      canvas.width = image.width;
      canvas.height = image.height + extraHeight;
  
      // White background
      context.fillStyle = "#ffffff";
      context.fillRect(0, 0, canvas.width, canvas.height);
  
      // Draw QR image
      context.drawImage(image, 0, 0);
  
      context.textAlign = "center";
  
      // qrc_UID - Bold, larger font, less top margin
      context.font = `bold ${uidFontSize}px Arial`;
      context.fillStyle = "#000000";
      context.fillText(qrcUID, canvas.width / 2, image.height + 12);
  
      // www.dirido.com - below UID with more bottom margin
      context.font = `${linkFontSize}px Arial`;
      context.fillStyle = "#000000";
      context.fillText("www.dirido.com", canvas.width / 2, image.height + 12 + linkLineHeight);
  
      // Trigger download
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = "QRCode.png";
      link.click();
    };
  
    image.onerror = () => {
      alert("Failed to load QR code image.");
    };
  };
  
  
  

  const [activeIndex, setActiveIndex] = useState(null);
  const [scanLogs, setScanLogs] = useState({});

  const handleLogTable = async (index, qrcUID) => {
    if (activeIndex === index) {
      setActiveIndex(null);
      return;
    }

    setActiveIndex(index);

    const token = getToken();

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/qrc/scan-logs/${qrcUID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setScanLogs((prevLogs) => ({
        ...prevLogs,
        [qrcUID]: response.data.data.scanLogs,
      }));
    } catch (error) {
      console.error("Error fetching scan logs:", error);
    }
  };

  const [qrcCode, setQrcCode] = useState("");
  // const handleArrowClick = () => {
  //   setShowDetails(!showDetails);
  // };
  const handleArrowClick = async () => {
    const token = getToken();
    if (!qrcCode) {
      toast.error("Please enter QR Code");
      return;
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/qrc/verify/${qrcCode}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(
        response?.data?.message || "QRC-code Verified Successfully"
      );
      handleGetQrc();
      setSelectedTab(1);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error(error?.response?.data?.message || "QRC Verification failed");
    } finally {
      setQrcCode("");
    }
  };

  const handleStatusChange = async (id, isActive) => {
    const newStatus = !isActive;
    const token = getToken();

    try {
      setLoadingFull(true);
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/qrc/status/${id}`,
        { isActive: newStatus },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      handleGetQrc();
      setSelectedCardIndex("");
      toast.success(
        `QR Status changed to ${
          newStatus ? "Active" : "Inactive"
        } successfully!`
      );
    } catch (error) {
      toast.error("Failed to change QR Status. Please try again.");
      console.error("Error changing status:", error);
    } finally {
      setLoadingFull(false);
    }
  };

  const handleToggleChange = (id, isActive) => {
    handleStatusChange(id, isActive);
  };

  const handleClear = () => {
    setFormDataEdit({
      category: "",
      userProfile: "",
      personalAdvice: "",
      doctersAdvice: "",
      doctersAdviceDocLink: "",
      doctersReportsLink: "",
      conditions: [],
      emergencyContacts: [],
    });
    setUploadedSingleFile(null);
    setSingleFile(null);
    setUploadedSingleFile1(null);
    setSingleFile1(null);
    setFinalUploadedFiles(null);
    setUploadedFiles(null);
  };

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      {loadingFull && (
        <div style={styles.loaderOverlay}>
          <CircularProgress style={{ color: "white" }} />
        </div>
      )}
      <>
        <div style={{ minHeight: "350px" }}>
          <Box className="user-profile-options">
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
            >
              {/* <Tab label="Register QRC" style={{ fontSize: "12px" }} /> */}
              <Tab
                label={t("create_qrc")}
                style={{ fontSize: "12px" }}
                onClick={handleClear}
              />
              <Tab
                label={t("qrc_list")}
                style={{ fontSize: "12px" }}
                onClick={handleClear}
              />
              <Tab label={t("qrc_log")} style={{ fontSize: "12px" }} />
            </Tabs>

            <Box>
              {selectedTab === 3 && (
                <div style={{ padding: "20px" }}>
                  <div className="cont_head">
                    <div
                      className={`sub_cont ${
                        expandedRow === "first" ? "expanded" : ""
                      }`}
                      onClick={() =>
                        setExpandedRow(expandedRow === "first" ? null : "first")
                      }
                    >
                      <LuShoppingBag
                        size={28}
                        style={{ paddingRight: "10px" }}
                      />{" "}
                      {t("register_critical_d_qrc")}
                    </div>
                    {expandedRow === "first" && (
                      <div className="sub_cont1">
                        <IoMdSearch
                          size={30}
                          style={{ paddingRight: "10px" }}
                        />
                        <input
                          placeholder={t("enter_qrc_code")}
                          className="input_sub"
                          value={qrcCode}
                          onChange={(e) => setQrcCode(e.target.value)}
                        />
                        <IoMdArrowForward
                          size={30}
                          style={{
                            paddingLeft: "10px",
                            cursor: "pointer",
                          }}
                          onClick={handleArrowClick}
                        />
                      </div>
                    )}
                  </div>
                  {showDetails && (
                    <div style={containerStyle}>
                      <div style={labelStyle}>
                        <img
                          src="./QR.png"
                          alt="QR"
                          style={{
                            width: "100px",
                            height: "100px",
                            marginRight: "20px",
                          }}
                        />
                        <h5>ABC1BHCWSC</h5>
                      </div>
                      <div style={labelStyle}>
                        <label style={headingStyle}>{t("user_name")}:</label>
                        <select
                          name="userName"
                          value={formData.userName}
                          onChange={handleChange}
                          style={inputStyle}
                        >
                          <option value="John Doe">John Doe</option>
                          <option value="Jane Smith">Jane Smith</option>
                        </select>
                      </div>
                      {/* <div style={{ marginBottom: '20px', textAlign: 'center' }}>
            <p style={{ margin: '10px 0', fontWeight: 'bold' }}>PHOTO WILL AUTOLOAD HERE</p>
            <button style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ccc', backgroundColor: '#f0f0f0', cursor: 'pointer' }}>Change Photo – Upload – Take One</button>
          </div> */}
                      <div style={labelStyle}>
                        <label style={headingStyle}>{t("address")}:</label>
                        <input
                          type="text"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          style={inputStyle}
                        />
                      </div>
                      <div style={labelStyle}>
                        <label style={headingStyle}>{t("age")}:</label>
                        <input
                          type="number"
                          name="age"
                          value={formData.age}
                          onChange={handleChange}
                          style={inputStyle}
                        />
                      </div>
                      <div style={labelStyle}>
                        <label style={headingStyle}>{t("blood_group")}:</label>
                        <input
                          type="text"
                          name="bloodType"
                          value={formData.bloodType}
                          onChange={handleChange}
                          style={inputStyle}
                        />
                      </div>
                      <div style={labelStyle}>
                        <label style={headingStyle}>
                          {t("personal_advice")}:
                        </label>
                        <textarea
                          name="personalAdvice"
                          value={formData.personalAdvice}
                          onChange={handleChange}
                          style={{ ...inputStyle }}
                        />
                      </div>
                      <div style={labelStyle}>
                        <label style={headingStyle}>
                          {t("doctors_advice")}:
                        </label>
                        <textarea
                          name="doctorAdvice"
                          value={formData.doctorAdvice}
                          onChange={handleChange}
                          style={{ ...inputStyle }}
                        />
                      </div>
                      <div style={labelStyle}>
                        <label style={headingStyle}>{t("category")}:</label>
                        <select
                          name="category"
                          value={formData.category}
                          onChange={handleChange}
                          style={inputStyle}
                        >
                          <option value="Health & Wellness">
                            {t("health_wellness")}
                          </option>
                          <option value="Fitness">{t("fitness")}</option>
                        </select>
                      </div>
                      <div style={labelStyle}>
                        <label style={headingStyle}>{t("conditions")}:</label>
                        <select
                          name="conditions"
                          value={formData.conditions}
                          onChange={handleChange}
                          style={inputStyle}
                        >
                          <option value="Hypertension, Diabetes">
                            {t("hypertension_diabetes")}
                          </option>
                          <option value="Asthma">{t("asthma")}</option>
                        </select>
                      </div>
                      <div style={labelStyle}>
                        <label style={headingStyle}>
                          {t("emergency_contact")}:
                        </label>
                        <select
                          name="emergencyContacts"
                          value={formData.emergencyContacts}
                          onChange={handleChange}
                          style={inputStyle}
                        >
                          <option value="Jane Doe (Wife) - +123 456 7890">
                            Jane Doe (Wife) - +123 456 7890
                          </option>
                          <option value="John Smith (Brother) - +987 654 3210">
                            John Smith (Brother) - +987 654 3210
                          </option>
                        </select>
                      </div>
                      <div style={labelStyle}>
                        <label style={headingStyle}>
                          {t("communication_channel")}:
                        </label>
                        <input
                          type="text"
                          name="communicationChannels"
                          value={formData.communicationChannels}
                          onChange={handleChange}
                          style={inputStyle}
                        />
                      </div>

                      <div style={labelStyle}>
                        <label style={headingStyle}>
                          {t("upload_profile_photo")}:
                        </label>
                        <input
                          type="file"
                          name="audioFile"
                          onChange={handleFileChange}
                          accept="audio/*"
                          style={inputStyle}
                        />
                      </div>
                      <div style={labelStyle}>
                        <label style={headingStyle}>
                          {t("upload_audio_voice")}:
                        </label>
                        <input
                          type="file"
                          name="audioFile"
                          onChange={handleFileChange}
                          accept="audio/*"
                          style={inputStyle}
                        />
                      </div>
                      <div style={labelStyle}>
                        <label style={headingStyle}>
                          {t("upload_doctors_advice")}:
                        </label>
                        <input
                          type="file"
                          name="doctorAdviceFile"
                          onChange={handleFileChange}
                          accept=".pdf,image/*"
                          style={inputStyle}
                        />
                      </div>
                      <div style={labelStyle}>
                        <label style={headingStyle}>
                          {t("upload_doctors_report")}:
                        </label>
                        <input
                          type="file"
                          name="doctorReportFile"
                          onChange={handleFileChange}
                          accept=".pdf,image/*"
                          style={inputStyle}
                        />
                      </div>
                      <div style={labelStyle}>
                        <label style={headingStyle}>
                          {t("upload_doctors_documents")}:
                        </label>
                        <input
                          type="file"
                          name="otherDocumentsFile"
                          onChange={handleFileChange}
                          accept=".pdf,image/*"
                          style={inputStyle}
                        />
                      </div>
                      <Button
                        type="submit"
                        className="w-100"
                        onClick={handleShowCard}
                      >
                        {t("preview")}
                      </Button>
                    </div>
                  )}
                  {qrcCard && (
                    <>
                      <div className="previewcontainer">
                        <div className="previewhead">
                          <span style={{ textTransform: "uppercase" }}>
                            DIRIDO
                          </span>
                          .com{" "}
                          <span className="previewheadfree">
                            {t("try_for_free")}
                          </span>
                        </div>
                        <div className="previewscanned">
                          {t("scanned_qr_code_message")}
                        </div>

                        <div className="profile-card">
                          <div className="profile-details">
                            <div className="name-location">
                              John Doe - Delhi{" "}
                              <FaMapMarkerAlt
                                style={{ verticalAlign: "middle" }}
                              />
                            </div>
                            <div className="profile-info">
                              <img
                                src="./profile.png"
                                alt="Profile"
                                className="profile-image"
                              />
                              <div className="details">
                                <p>
                                  <strong>{t("age")}:</strong> 30
                                </p>
                                <p>
                                  <strong>{t("blood_group")}:</strong> B+
                                </p>
                                <p>
                                  <strong>{t("problem")}:</strong> Hypertension
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="additional-info">
                          <div className="contact-alert">
                            <p>{t("emergency_contact")} - John Snow</p>
                            <FaPhoneAlt
                              size={20}
                              style={{
                                verticalAlign: "middle",
                                marginLeft: "8px",
                              }}
                            />
                          </div>
                          <h1 className="waiting-help">
                            {t("waiting_for_help")}
                          </h1>
                          <h1 className="waiting-help">{t("advising_here")}</h1>

                          <textarea className="advice-textarea" readOnly>
                            {t("emergency_guidelines_message")}
                          </textarea>

                          <h2 className="doctor-advice-heading">
                            {t("doctor_advice_heading")}
                          </h2>

                          <textarea className="advice-textarea" readOnly>
                            {t("contact_healthcare_provider_message")}
                          </textarea>
                        </div>
                        <div className="report-card">
                          <div className="report-header">
                            {t("download_or_share_report")}
                          </div>
                          <div className="report-actions">
                            <div className="pdf-section">
                              <div className="pdf-icon-container">
                                <div>
                                  {" "}
                                  <FaShareAlt className="action-icon" />
                                  <FaFilePdf size={38} className="pdf-icon" />
                                  <FaDownload className="action-icon" />
                                </div>
                                <p>{t("report")}</p>
                              </div>
                              <div className="pdf-icon-container">
                                <div>
                                  {" "}
                                  <FaShareAlt className="action-icon" />
                                  <FaFilePdf size={38} className="pdf-icon" />
                                  <FaDownload className="action-icon" />
                                </div>
                                <p>{t("advice")}</p>
                              </div>
                            </div>
                            <div className="share-download">
                              <FaShareAlt size={18} className="action-icon" />
                              <h5>{t("download_or_share_page")}</h5>
                              <FaDownload size={18} className="action-icon" />
                            </div>
                          </div>
                        </div>
                        <div className="health-card">
                          <div className="health-message">
                            <div>{t("good_health_wish")}</div>
                          </div>
                          <div className="powered-by">
                            <div>
                              {t("powered_by")} {projectName}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="navigation-buttons">
                        <button
                          className="nav-button back-button"
                          onClick={backQrc}
                        >
                          {t("back")}
                        </button>
                        <button
                          className="nav-button back-button"
                          onClick={finalQRC}
                        >
                          {t("next")}
                        </button>
                      </div>
                    </>
                  )}
                  {qrcCardCode && (
                    <div>
                      <div className="second_cont">
                        <div
                          className="sub_second_cont"
                          style={{
                            position: "relative",
                            flexDirection: "column",
                          }}
                        >
                          <div className="menu_icon" onClick={toggleMenu}>
                            <BiDotsVerticalRounded size={24} />
                          </div>
                          {showMenu && (
                            <div className="menu">
                              <button onClick={downloadQR}>
                                {t("download")}
                              </button>
                            </div>
                          )}
                          <img
                            style={{ display: "flex" }}
                            src="/QR.png"
                            className="image_second"
                          />
                          <div style={{ display: "flex" }}>FSX56DY67F67</div>
                        </div>
                        <div className="sub_second_cont">
                          <div className="communication-channel">
                            <h2>{t("select_communication_channel")}</h2>
                            <div className="channel-options">
                              <label>
                                <input
                                  type="checkbox"
                                  value="Email"
                                  checked={selectedChannels.includes("Email")}
                                  onChange={handleChannelChange}
                                />
                                {t("email_label")}
                              </label>
                              <label>
                                <input
                                  type="checkbox"
                                  value="WhatsApp"
                                  checked={selectedChannels.includes(
                                    "WhatsApp"
                                  )}
                                  onChange={handleChannelChange}
                                />
                                {t("whatsapp")}
                              </label>
                              <label>
                                <input
                                  type="checkbox"
                                  value="SMS"
                                  checked={selectedChannels.includes("SMS")}
                                  onChange={handleChannelChange}
                                />
                                {t("sms")}
                              </label>
                            </div>

                            <h2>{t("buy_credits_package")}</h2>
                            <div className="package-options">
                              <label>
                                <input
                                  type="radio"
                                  name="package"
                                  value="Package 1"
                                  checked={selectedPackage === "Package 1"}
                                  onChange={handlePackageChange}
                                />
                                {t("package")} 1
                              </label>
                              <label>
                                <input
                                  type="radio"
                                  name="package"
                                  value="Package 2"
                                  checked={selectedPackage === "Package 2"}
                                  onChange={handlePackageChange}
                                />
                                {t("package")} 2
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="navigation-buttons">
                        <button
                          className="nav-button back-button"
                          onClick={backQrc1}
                        >
                          {t("back")}
                        </button>
                        <button
                          className="nav-button back-button"
                          onClick={finalComplete}
                        >
                          {t("submit_button")}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {selectedTab === 0 && (
                <div>
                  <Box component="form" style={{ margin: "20px" }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          label={t("user_profile")}
                          name="userProfile"
                          variant="outlined"
                          fullWidth
                          select
                          required
                          value={formDataEdit.userProfile}
                          onChange={handleChange1}
                          disabled={!user || user.length === 0}
                        >
                          {user?.map((data) => (
                            <MenuItem key={data._id} value={data._id}>
                              {data.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label={t("personal_advice")}
                          name="personalAdvice"
                          variant="outlined"
                          fullWidth
                          required
                          multiline
                          rows={4}
                          value={formDataEdit.personalAdvice}
                          onChange={handleChange1}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          label={t("doctors_advice")}
                          name="doctersAdvice"
                          variant="outlined"
                          fullWidth
                          required
                          multiline
                          rows={4}
                          value={formDataEdit.doctersAdvice}
                          onChange={handleChange1}
                        />
                      </Grid>
                      {/* Category Selection */}

                      <Grid item xs={12}>
                        <TextField
                          label={t("category")}
                          name="category"
                          variant="outlined"
                          fullWidth
                          select
                          required
                          value={formDataEdit.category}
                          onChange={handleChange1}
                          disabled={!categoryAll || categoryAll.length === 0}
                        >
                          {categoryAll?.map((category) => (
                            <MenuItem key={category._id} value={category._id}>
                              {category.categoryName}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      {/* Conditions Selection */}
                      <Grid item xs={12}>
                        <FormControl fullWidth variant="outlined" required>
                          <InputLabel>{t("conditions")}</InputLabel>
                          <Select
                            label={t("conditions")}
                            name="conditions"
                            multiple
                            value={formDataEdit.conditions}
                            onChange={handleConditionChange}
                            disabled={
                              !conditionAll || conditionAll.length === 0
                            }
                            renderValue={(selected) => (
                              <div>
                                {selected?.map((value) => (
                                  <div key={value}>
                                    {
                                      conditionAll.find(
                                        (cond) => cond._id === value
                                      )?.conditionName
                                    }
                                  </div>
                                ))}
                              </div>
                            )}
                          >
                            {conditionAll?.map((condition) => (
                              <MenuItem
                                key={condition._id}
                                value={condition._id}
                              >
                                <Checkbox
                                  checked={
                                    formDataEdit.conditions.indexOf(
                                      condition._id
                                    ) > -1
                                  }
                                />
                                <ListItemText
                                  primary={condition.conditionName}
                                />
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      {/* 
    <input
      id="file-input"
      type="file"
      name="image"
      accept="application/pdf"
      multiple
      onChange={handleSingleFileInputChange}
      /> */}
                      <Grid item xs={12}>
                        <TextField
                          label={t("emergency_contact")}
                          name="emergencyContacts"
                          variant="outlined"
                          fullWidth
                          select
                          required
                          value={formDataEdit.emergencyContacts}
                          onChange={handleEmergencyContactChange}
                          disabled={
                            !emergencyContactAll ||
                            emergencyContactAll.length === 0
                          }
                        >
                          {emergencyContactAll?.map((contact) => (
                            <MenuItem key={contact._id} value={contact._id}>
                              {contact.firstName} {contact.lastName}
                            </MenuItem>
                          ))}
                        </TextField>

                        <Grid item xs={12}>
                          <label
                            htmlFor="doctersAdviceFileInput"
                            style={{
                              cursor: "pointer",
                              width: "100%",
                              marginBottom: "10px",
                            }}
                          >
                            <input
                              id="doctersAdviceFileInput"
                              type="file"
                              name="doctersAdvice"
                              accept="application/pdf"
                              style={{ display: "none" }}
                              onChange={handleSingleFileInputChange}
                            />
                            <div className="w-100 mt-3 bg-white border border-primary text-primary d-flex align-items-center justify-content-center gap-1 py-2 mb-1">
                              {uploadedSingleFile ? (
                                <div className="d-flex flex-column align-items-center">
                                  <MdOutlineDone /> {t("uploaded")}
                                  <span>{uploadedSingleFile.name}</span>
                                  <button
                                    style={{
                                      marginTop: "10px",
                                      backgroundColor: "transparent",
                                      border: "none",
                                      color: "red",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() => {
                                      setUploadedSingleFile(null); // Clear the uploaded file state
                                      setSingleFile(null); // Reset the selected file
                                    }}
                                  >
                                    {t("change_doctors_advice")}
                                  </button>
                                </div>
                              ) : (
                                <>
                                  <GoUpload />{" "}
                                  <span>{t("upload_doctors_advice_pdf")}</span>
                                </>
                              )}
                            </div>
                          </label>
                        </Grid>
                        <Grid item xs={12}>
                          <label
                            htmlFor="doctersReportsLink"
                            style={{
                              cursor: "pointer",
                              width: "100%",
                              marginBottom: "10px",
                            }}
                          >
                            <input
                              id="doctersReportsLink"
                              type="file"
                              name="doctersReportsLink"
                              accept="application/pdf"
                              style={{ display: "none" }}
                              onChange={handleSingleFileInputChange1}
                            />
                            <div className="w-100 mt-3 bg-white border border-primary text-primary d-flex align-items-center justify-content-center gap-1 py-2 mb-1">
                              {uploadedSingleFile1 ? (
                                <div className="d-flex flex-column align-items-center">
                                  <MdOutlineDone /> {t("uploaded")}
                                  <span>{uploadedSingleFile1.name}</span>
                                  <button
                                    style={{
                                      marginTop: "10px",
                                      backgroundColor: "transparent",
                                      border: "none",
                                      color: "red",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() => {
                                      setUploadedSingleFile1(null);
                                      setSingleFile1(null);
                                    }}
                                  >
                                    {t("change_doctors_report")}
                                  </button>
                                </div>
                              ) : (
                                <>
                                  <GoUpload />{" "}
                                  <span>{t("upload_doctors_report_pdf")}</span>
                                </>
                              )}
                            </div>
                          </label>
                        </Grid>

                        {/* <label
                                                                    htmlFor="file-input"
                                                                    style={{ cursor: "pointer", width: "100%", marginBottom:"10px" }}
                                                                >

                                                                    <input
                                                                        id="file-input"
                                                                        type="file"
                                                                        name="image"
                                                                        accept="application/pdf"
                                                                        multiple
                                                                        style={{ display: "none" }}
                                                                        onChange={handleFileInputChange}
                                                                    />
                                                                    
                                                                    <div className="w-100 mt-3 bg-white border border-primary text-primary d-flex align-items-center justify-content-center gap-1 py-2 mb-1">{file ? <><MdOutlineDone /> <span>uploaded</span></> : <><GoUpload /> <span>Upload PDF</span> </>}  </div>

                                                                </label>
                                                                <div className="d-flex gap-3">
  {finalUploadedFiles?.map((doc, index) => (
    <div key={index} className="position-relative d-flex flex-column">
      <Link
        to={`${doc}`}
        target="_blank"
        className="pointer text-dark d-flex flex-column"
        style={{ fontSize: "10px", textDecoration: "none" }}
      >
        <img
          src={pdf}
          alt="documents"
          style={{
            background: 'rgb(221 221 221)',
            borderRadius: '20px',
            padding: '10px',
            width: '50px',
            height: '50px',
          }}
        />
        {splitFileLink(doc)}
        <br />
      </Link>
      <AiOutlineClose
        onClick={() => handleRemoveFile(doc)}
        style={{
          position: "absolute",
          top: "-5px",
          right: "-5px",
          cursor: "pointer",
          backgroundColor: "#fff",
          borderRadius: "50%",
          padding: "2px",
          border: "1px solid #ccc",
          boxShadow: "0 0 3px rgba(0, 0, 0, 0.2)"
        }}
      />
    </div>
  ))}
</div> */}
                      </Grid>

                      {/* Save Button */}
                      <Grid
                        container
                        item
                        xs={12}
                        mt={2}
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Grid
                          item
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <Button
                            onClick={handleGenerateQrc}
                            style={{ width: "130px" }}
                          >
                            {t("generate_qrc")}
                          </Button>
                        </Grid>

                        {/* <Grid item>
                <Button
                    // onClick={() => handleEditClickclose(index)}
                    fullWidth
                    style={{ marginLeft: '20px', maxWidth: '200px' }} // Optional: limits button width
                >
                    Cancel
                </Button>
            </Grid> */}
                      </Grid>
                    </Grid>
                  </Box>
                </div>
              )}
              {selectedTab === 1 && (
                <div>
                  {/* <Card.Body> */}
                    <div className="d-flex align-items-center mt-1">
                      <div className="w-100">
                        {qrcData && qrcData.length === 0 ? (
                          <p style={{padding :"10px"}}>{t("no_qrc_list")}</p>
                        ) : (
                          qrcData?.map((i, index) => (
                            <div
                              key={index}
                              className=" d-flex flex-column justify-content-between align-items-center gap-2 w-100"
                              style={{ borderBottom: "1px solid #dee2e682" }}
                            >
                              <div
                                className="d-flex justify-content-between align-items-center gap-2 w-100 py-1"
                                onClick={() => handleCardClick(index, i?._id)}
                                style={{ cursor: "pointer", height: "50px" }}
                              >
                                <div
                                  className="d-flex align-items-center"
                                  style={{ height: "50px" }}
                                >
                                  {/* <span style={{ width: "50px", fontSize: "14px", color: i?.isActive ? 'green' : 'red' }}>
        {i?.isActive ? 'Active' : 'Inactive'}
    </span> */}

                                  <Switch
                                    checked={i?.isActive}
                                    onChange={() =>
                                      handleToggleChange(i?._id, i?.isActive)
                                    }
                                    color="primary"
                                  />
                                  <span
                                    style={{
                                      width: "50px",
                                      fontSize: "14px",
                                      color: i?.isActive ? "green" : "red",
                                    }}
                                  >
                                    {i?.isActive ? "Active" : "Inactive"}
                                  </span>
                                  <img
                                    src={i?.qrCodeUrl ? i?.qrCodeUrl : QR1}
                                    alt="qr"
                                    width={40}
                                    height={40}
                                  />
                                  <div
                                    style={{
                                      marginLeft: "10px",
                                      fontSize: "16px",
                                    }}
                                  >
                                    <div>
                                      {i?.qrc_UID}{" "}
                                      {/* {i?.qrcContentId?.criticalUserProfileId
                                        ?.name && (
                                        <>
                                          {" - "}
                                          <span style={{ fontSize: "12px" }}>
                                            {
                                              i?.qrcContentId
                                                ?.criticalUserProfileId?.name
                                            }
                                          </span>
                                        </>
                                      )} */}
                                    </div>
                                     {/* <span style={{ fontSize: "12px" }}>
                                            {
                                              i?.qrcContentId
                                                ?.criticalUserProfileId?.name
                                            }
                                          </span> */}
                                   {i?.qrcContentId?.criticalUserProfileId
                                        ?.name && ( <div style={{ fontSize: "12px",  height: "20px", display: "flex" }}>
           {i?.qrcContentId ?.criticalUserProfileId?.name}
        </div>)}
                                  </div>
                                </div>

                                {selectedCardIndex === index ? (
                                  <FaChevronUp style={{ fontSize: "18px" }} />
                                ) : (
                                  <FaChevronDown style={{ fontSize: "18px" }} />
                                )}
                              </div>

                              {selectedCardIndex === index && (
                                <div className="details-section w-100 py-2">
                                  {loading ? (
                                    <p>{t("query_loading")}</p>
                                  ) : (
                                    <>
                                      {editModeIndex === index ? (
                                        // Edit Form
                                        <div>
                                          <h5>{t("edit_category_details")}</h5>
                                          <Box
                                            component="form"
                                            style={{ marginTop: "20px" }}
                                          >
                                            <Grid container spacing={2}>
                                              <Grid item xs={12}>
                                                <TextField
                                                  label={t("user_profile")}
                                                  name="userProfile"
                                                  variant="outlined"
                                                  fullWidth
                                                  select
                                                  required
                                                  value={
                                                    formDataEdit.userProfile
                                                  }
                                                  onChange={handleChange1}
                                                >
                                                  {user?.map((data) => (
                                                    <MenuItem
                                                      key={data._id}
                                                      value={data._id}
                                                    >
                                                      {data.name}
                                                    </MenuItem>
                                                  ))}
                                                </TextField>
                                              </Grid>
                                              <Grid item xs={12}>
                                                <TextField
                                                  label={t("personal_advice")}
                                                  name="personalAdvice"
                                                  variant="outlined"
                                                  fullWidth
                                                  required
                                                  multiline
                                                  rows={4}
                                                  value={
                                                    formDataEdit.personalAdvice
                                                  }
                                                  onChange={handleChange1}
                                                />
                                              </Grid>
                                              <Grid item xs={12}>
                                                <TextField
                                                  label={t("Advice")}
                                                  name="doctersAdvice"
                                                  variant="outlined"
                                                  fullWidth
                                                  required
                                                  multiline
                                                  rows={4}
                                                  value={
                                                    formDataEdit.doctersAdvice
                                                  }
                                                  onChange={handleChange1}
                                                />
                                              </Grid>
                                              {/* Category Selection */}

                                              <Grid item xs={12}>
                                                <TextField
                                                  label={t("category")}
                                                  name="category"
                                                  variant="outlined"
                                                  fullWidth
                                                  select
                                                  required
                                                  value={formDataEdit.category}
                                                  onChange={handleChange1}
                                                >
                                                  {categoryAll?.map(
                                                    (category) => (
                                                      <MenuItem
                                                        key={category._id}
                                                        value={category._id}
                                                      >
                                                        {category.categoryName}
                                                      </MenuItem>
                                                    )
                                                  )}
                                                </TextField>
                                              </Grid>

                                              {/* Conditions Selection */}
                                              <Grid item xs={12}>
                                                <FormControl
                                                  fullWidth
                                                  variant="outlined"
                                                  required
                                                >
                                                  <InputLabel>
                                                    {t("conditions")}
                                                  </InputLabel>
                                                  <Select
                                                    label={t("conditions")}
                                                    name="conditions"
                                                    multiple
                                                    value={
                                                      formDataEdit.conditions
                                                    }
                                                    onChange={
                                                      handleConditionChange
                                                    }
                                                    renderValue={(selected) => (
                                                      <div>
                                                        {selected?.map(
                                                          (value) => (
                                                            <div key={value}>
                                                              {
                                                                conditionAll.find(
                                                                  (cond) =>
                                                                    cond._id ===
                                                                    value
                                                                )?.conditionName
                                                              }
                                                            </div>
                                                          )
                                                        )}
                                                      </div>
                                                    )}
                                                  >
                                                    {conditionAll?.map(
                                                      (condition) => (
                                                        <MenuItem
                                                          key={condition._id}
                                                          value={condition._id}
                                                        >
                                                          <Checkbox
                                                            checked={
                                                              formDataEdit.conditions.indexOf(
                                                                condition._id
                                                              ) > -1
                                                            }
                                                          />
                                                          <ListItemText
                                                            primary={
                                                              condition.conditionName
                                                            }
                                                          />
                                                        </MenuItem>
                                                      )
                                                    )}
                                                  </Select>
                                                </FormControl>
                                              </Grid>

                                              {/* 
    <input
      id="file-input"
      type="file"
      name="image"
      accept="application/pdf"
      multiple
      onChange={handleSingleFileInputChange}
      /> */}
                                              <Grid item xs={12}>
                                                <TextField
                                                  label={t("emergency_contact")}
                                                  name="emergencyContacts"
                                                  variant="outlined"
                                                  fullWidth
                                                  select
                                                  required
                                                  value={
                                                    formDataEdit.emergencyContacts
                                                  }
                                                  onChange={
                                                    handleEmergencyContactChange
                                                  }
                                                >
                                                  {emergencyContactAll?.map(
                                                    (contact) => (
                                                      <MenuItem
                                                        key={contact._id}
                                                        value={contact._id}
                                                      >
                                                        {contact.firstName}{" "}
                                                        {contact.lastName}
                                                      </MenuItem>
                                                    )
                                                  )}
                                                </TextField>

                                                <Grid item xs={12}>
                                                  <label
                                                    htmlFor="doctersAdviceFileInput"
                                                    style={{
                                                      cursor: "pointer",
                                                      width: "100%",
                                                      marginBottom: "10px",
                                                    }}
                                                  >
                                                    <input
                                                      id="doctersAdviceFileInput"
                                                      type="file"
                                                      name="doctersAdvice"
                                                      accept="application/pdf"
                                                      style={{
                                                        display: "none",
                                                      }}
                                                      onChange={
                                                        handleSingleFileInputChange
                                                      }
                                                    />
                                                    <div className="w-100 mt-3 bg-white border border-primary text-primary d-flex align-items-center justify-content-center gap-1 py-2 mb-1">
                                                      {uploadedSingleFile ? (
                                                        <div className="d-flex flex-column align-items-center">
                                                          <MdOutlineDone />{" "}
                                                          {t("uploaded")}
                                                          <span>
                                                            {
                                                              uploadedSingleFile.name
                                                            }
                                                          </span>
                                                          <button
                                                            style={{
                                                              marginTop: "10px",
                                                              backgroundColor:
                                                                "transparent",
                                                              border: "none",
                                                              color: "red",
                                                              cursor: "pointer",
                                                              textDecoration:
                                                                "underline",
                                                            }}
                                                            onClick={() => {
                                                              setUploadedSingleFile(
                                                                null
                                                              ); // Clear the uploaded file state
                                                              setSingleFile(
                                                                null
                                                              ); // Reset the selected file
                                                            }}
                                                          >
                                                            {t(
                                                              "change_doctors_advice"
                                                            )}
                                                          </button>
                                                        </div>
                                                      ) : (
                                                        <>
                                                          <GoUpload />{" "}
                                                          <span>
                                                            {t(
                                                              "upload_doctors_advice_pdf"
                                                            )}
                                                          </span>
                                                        </>
                                                      )}
                                                    </div>
                                                  </label>
                                                </Grid>
                                                <Grid item xs={12}>
                                                  <label
                                                    htmlFor="doctersReportsLink"
                                                    style={{
                                                      cursor: "pointer",
                                                      width: "100%",
                                                      marginBottom: "10px",
                                                    }}
                                                  >
                                                    <input
                                                      id="doctersReportsLink"
                                                      type="file"
                                                      name="doctersReportsLink"
                                                      accept="application/pdf"
                                                      style={{
                                                        display: "none",
                                                      }}
                                                      onChange={
                                                        handleSingleFileInputChange1
                                                      }
                                                    />
                                                    <div className="w-100 mt-3 bg-white border border-primary text-primary d-flex align-items-center justify-content-center gap-1 py-2 mb-1">
                                                      {uploadedSingleFile1 ? (
                                                        <div className="d-flex flex-column align-items-center">
                                                          <MdOutlineDone />{" "}
                                                          {t("uploaded")}
                                                          <span>
                                                            {
                                                              uploadedSingleFile1.name
                                                            }
                                                          </span>
                                                          <button
                                                            style={{
                                                              marginTop: "10px",
                                                              backgroundColor:
                                                                "transparent",
                                                              border: "none",
                                                              color: "red",
                                                              cursor: "pointer",
                                                              textDecoration:
                                                                "underline",
                                                            }}
                                                            onClick={() => {
                                                              setUploadedSingleFile1(
                                                                null
                                                              ); // Clear the uploaded file state
                                                              setSingleFile1(
                                                                null
                                                              ); // Reset the selected file
                                                            }}
                                                          >
                                                            {t(
                                                              "change_doctors_report"
                                                            )}
                                                          </button>
                                                        </div>
                                                      ) : (
                                                        <>
                                                          <GoUpload />{" "}
                                                          <span>
                                                            {t(
                                                              "upload_doctors_report_pdf"
                                                            )}
                                                          </span>
                                                        </>
                                                      )}
                                                    </div>
                                                  </label>
                                                </Grid>
                                              </Grid>

                                              {/* Emergency Contacts Selection */}

                                              {/* Save Button */}
                                              <Grid
                                                container
                                                item
                                                xs={12}
                                                mt={2}
                                                justifyContent="center"
                                                alignItems="center"
                                              >
                                                <Grid item>
                                                  <Button
                                                    onClick={handleSubmitEdit}
                                                    fullWidth
                                                    style={{
                                                      maxWidth: "200px",
                                                    }} // Optional: limits button width
                                                  >
                                                    {t("save")}
                                                  </Button>
                                                </Grid>
                                                <Grid item>
                                                  <Button
                                                    onClick={() =>
                                                      handleEditClickclose(
                                                        index
                                                      )
                                                    }
                                                    fullWidth
                                                    style={{
                                                      marginLeft: "20px",
                                                      maxWidth: "200px",
                                                    }}
                                                  >
                                                    {t("cancel")}
                                                  </Button>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </Box>
                                        </div>
                                      ) : (
                                        <>
                                          <>
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: "10px",
                                                justifyContent: "space-evenly",
                                              }}
                                            >
                                              {/* <Button style={{ marginBlock: '5px', width:"32%", justifyContent: "center" }} onClick={() => handleStatusChange(cardDetails._id, cardDetails.isActive)}>Change Status to {cardDetails?.isActive ? ('Inactive'):('Active')}</Button> */}
                                              <canvas
                                                ref={canvasRef}
                                                style={{ display: "none" }}
                                              />

                                              <Button
                                                onClick={() => {
                                                  if (userDetail?.isEnrolledInCriticalD && userDetail?.isCriticalDPlanPaid) {
                                                    handleDownloadQRCPaid(cardDetails);
                                                  } else {
                                                    handleDownloadQRCFree(cardDetails);
                                                  }
                                                }}
                                                style={{
                                                  marginBlock: "5px",
                                                  width: "49%",
                                                  justifyContent: "center",
                                                  whiteSpace:"nowrap"
                                                }}
                                              >
                                                {t("download_qr_code")}
                                              </Button>
                                              <Button
                                                onClick={() =>
                                                  handleEditClick(index)
                                                }
                                                style={{
                                                  marginBlock: "5px",
                                                  width: "49%",
                                                  justifyContent: "center",
                                                }}
                                              >
                                                {t("edit")}
                                              </Button>
                                            </div>
                                          </>
                                          {qrCodeDetail(cardDetails)}
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>
                              )}
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  {/* </Card.Body> */}
                  <QrcDetails
                    handleGetAdvice={handleGetAdvice}
                    condition={condition}
                    category={category}
                    advice={advice}
                    emergencyContact={emergencyContact}
                    qrcId={qrcId}
                    handleGetQrc={handleGetQrc}
                    desPage={desPage}
                    setDesPage={setDesPage}
                  />
                  <Modal
                    size="md"
                    className="fade"
                    id="qr-modal"
                    style={{ backdropFilter: "blur(100px)" }}
                    onHide={() => setQrPopupOpen(false)}
                    show={qrPopupOpen}
                    centered
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>{t("qr_code")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                      <img
                        src={qrImageUrl}
                        alt="QR Code"
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </Modal.Body>
                  </Modal>
                </div>
              )}

              {selectedTab === 2 && (
                <div>
                  {qrcData && qrcData.length > 0 ? (
                    qrcData?.map(
                      (item, index) =>
                        item.isActive && (
                          <div className="list" key={index}>
                            <div style={{ display: "flex" }}>
                              <p className="list_sub">{item.qrc_UID}</p>
                              <p
                                className="list_sub1"
                                style={{ width: "50px" }}
                              >
                                <AiOutlineInfoCircle
                                  size={28}
                                  onClick={() =>
                                    handleLogTable(index, item.qrc_UID)
                                  }
                                  style={{ cursor: "pointer" }}
                                />
                              </p>
                            </div>
                            {activeIndex === index && (
                              <div
                                style={{
                                  boxSizing: "border-box",
                                  overflowX: "auto",
                                }}
                              >
                                {scanLogs[item.qrc_UID] &&
                                scanLogs[item.qrc_UID].length > 0 ? (
                                  <table
                                    style={{
                                      width: "100%",
                                      borderCollapse: "collapse",
                                      marginTop: "10px",
                                      overflowX: "auto",
                                    }}
                                  >
                                    <thead>
                                      <tr
                                        style={{
                                          background: "rgb(0,95,134)",
                                          color: "white",
                                          fontWeight: "600",
                                          fontSize: "16px",
                                        }}
                                      >
                                        <th
                                          style={{
                                            border: "2px solid white",
                                            padding: "8px",
                                          }}
                                        >
                                          {t("scan_time")}
                                        </th>
                                        <th
                                          style={{
                                            border: "2px solid white",
                                            padding: "8px",
                                          }}
                                        >
                                          {t("location")}
                                        </th>
                                        <th
                                          style={{
                                            border: "2px solid white",
                                            padding: "8px",
                                          }}
                                        >
                                          {t("client_ip")}
                                        </th>
                                        <th
                                          style={{
                                            border: "2px solid white",
                                            padding: "8px",
                                          }}
                                        >
                                          {t("client_os")}
                                        </th>
                                        <th
                                          style={{
                                            border: "2px solid white",
                                            padding: "8px",
                                          }}
                                        >
                                          {t("coordinates")}
                                        </th>
                                        <th
                                          style={{
                                            border: "2px solid white",
                                            padding: "8px",
                                          }}
                                        >
                                          {t("scanned_searched")}
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {scanLogs[item.qrc_UID]?.map((log) => (
                                        <tr key={log._id}>
                                          <td
                                            style={{
                                              fontSize: "16px",
                                              border: "2px solid white",
                                              padding: "8px",
                                              background: "rgb(201,209,216)",
                                            }}
                                          >
                                            {new Date(
                                              log.createdAt
                                            ).toLocaleString()}
                                          </td>
                                          <td
                                            style={{
                                              fontSize: "16px",
                                              border: "2px solid white",
                                              padding: "8px",
                                              background: "rgb(201,209,216)",
                                            }}
                                          >
                                            {log.city}, {log.country}
                                          </td>
                                          <td
                                            style={{
                                              fontSize: "16px",
                                              border: "2px solid white",
                                              padding: "8px",
                                              background: "rgb(201,209,216)",
                                            }}
                                          >
                                            {log.clientIp}
                                          </td>
                                          <td
                                            style={{
                                              fontSize: "16px",
                                              border: "2px solid white",
                                              padding: "8px",
                                              background: "rgb(201,209,216)",
                                            }}
                                          >
                                            {log.clientOs}
                                          </td>
                                          <td
                                            style={{
                                              fontSize: "16px",
                                              border: "2px solid white",
                                              padding: "8px",
                                              background: "rgb(201,209,216)",
                                            }}
                                          >
                                            <a
                                              href={`https://www.google.com/maps?q=${log.lat},${log.lon}`}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              style={{
                                                color: "blue",
                                                textDecoration: "underline",
                                                cursor: "pointer",
                                              }}
                                            >
                                              {log.lat}, {log.lon}
                                            </a>
                                            {/* {log.lat}, {log.lon} */}
                                          </td>
                                          <td
                                            style={{
                                              fontSize: "16px",
                                              border: "2px solid white",
                                              padding: "8px",
                                              background: "rgb(201,209,216)",
                                            }}
                                          >
                                            {log?.isSearched
                                              ? "Searched"
                                              : "Scanned"}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                ) : (
                                  <p style={{ padding: "10px", color: "#333" }}>
                                    {t("no_scan_logs")}
                                  </p>
                                )}
                              </div>
                            )}
                          </div>
                        )
                    )
                  ) : (
                    <p style={{ padding: "10px", color: "#333" }}>
                      {t("no_active_qrc_data")}
                    </p>
                  )}
                </div>
              )}
            </Box>
          </Box>
        </div>
      <div style={{ width: "100%", paddingTop: "10px" }}>
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-evenly",
      alignItems: "center",
      gap: "10px",
      margin: 0,
      padding: 0,
    }}
  >
    {available?.dynamicQRC?.available >= 0 && (
      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <strong>{t("availableQrc")}:</strong>
        <span>{available?.dynamicQRC?.available}</span>
      </div>
    )}

    {available?.sms?.available >= 0 && (
      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <strong>{t("availableSms")}:</strong>
        <span>{available?.sms?.available}</span>
      </div>
    )}

    {available?.whatsapp?.available >= 0 && (
      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <strong>{t("availableWhatsapp")}:</strong>
        <span>{available?.whatsapp?.available}</span>
      </div>
    )}
  </div>
</div>

      </>
    </>
  );
};
const styles = {
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};
export default CreateQrcTab;
